import React from 'react'
import { Moon } from 'lucide-react'
import { useTheme } from '../../shared/contexts/ThemeContext'
import { Button } from '../ui/button'

/**
 * Cinematic shell is dark-only; toggle hidden until light theme is redesigned.
 */
export const ThemeToggle: React.FC = () => {
  useTheme()

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      disabled
      className="cursor-default bg-white/5 text-white/50 hover:bg-white/5 hover:text-white/50"
      aria-label="Dark mode (default)"
      title="SALT uses cinematic dark mode"
    >
      <Moon className="h-4 w-4" />
      <span className="hidden text-sm font-medium sm:inline">Dark</span>
    </Button>
  )
}
